export const defaultFonts = [
  {
    Label: _TL_('Long headline'),
    TextAssetType: 'LongHeadline',
    Typeface: '',
    Weight: '',
    helpTopic: 'pop_BA_Brand_LongHeadline',
    helpLabel: _TL_('Learn about long headlines'),
  },
  {
    Label: _TL_('Short headline'),
    TextAssetType: 'ShortHeadline',
    Typeface: '',
    Weight: '',
    helpTopic: 'pop_BA_Brand_ShortHeadline ',
    helpLabel: _TL_('Learn about short headlines'),
  },
  {
    Label: _TL_('Description'),
    TextAssetType: 'Description',
    Typeface: '',
    Weight: '',
    helpTopic: 'pop_BA_Brand_Description',
    helpLabel: _TL_('Learn about descriptions'),
  },
  {
    Label: _TL_('Call to action'),
    TextAssetType: 'CallToAction',
    Typeface: '',
    Weight: '',
    helpTopic: 'pop_BA_Brand_CTA',
    helpLabel: _TL_('Learn about calls to action'),
  },
];

export const overrideFontWeights = [
  { key: 'Normal', text: _TL_('Normal') },
  { key: 'Bold', text: _TL_('Bold') },
];
